import { BlitzPage, Routes } from "@blitzjs/next";
import Layout from "src/app/core/layouts/Layout"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { DashboardLoginPage } from "src/app/dashboard/feature-login/DashboardLoginPage"

const DashboardLogin: BlitzPage = () => {
  return <DashboardLoginPage />
}

DashboardLogin.redirectAuthenticatedTo = ({ session }) => {
  if (session.orgIds) return Routes.DashboardIndex()

  return false
}
DashboardLogin.getLayout = (page) => <Layout title="Log In">{page}</Layout>

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "dashboard"])),
      // Will be passed to the page component as props
    },
  }
}

export default DashboardLogin
